import i18next from 'i18next';
import CalculatorMultipleSelectInput from '../../../../calculatorInputs/CalculatorMultipleSelectInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const ContainsValue = ({ fieldName, showLabel, availableValueOptions, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();

  return <CalculatorMultipleSelectInput
    fieldName={`${fieldName}`}
    isRequired
    options={availableValueOptions}
    label={`${
      showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
    }`}
    uxVariant="criteriaInput"
    variant="standard"
    placeholder={i18next.t(
      `calculator.dialog.create.placeholder.selectValues`
    )}
    triggerOnContinue
    disabled={readOnly}
    validate={(value) => {
      if (value.length === 0) {
        setError(`${fieldName}`, {
          type: 'manual',
          message: i18next.t(`calculator.errors.criterionValueEmpty`),
        });
        return false;
      } else {
        clearErrors(`${fieldName}`);
        return true;
      }
    }}
  />
}

export default ContainsValue;